/* 
  styles graciously shared by `blujedis`
  https://github.com/blujedis
*/

.switch {
  display: inline-flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  user-select: none;
  font-weight: normal;
  height: 32px;
}

.switchDisabled {
  cursor: not-allowed;
}

.switch > input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.switch > input:checked ~ .switchControl {
  background-color: var(--primary);
}

.switch > input:checked ~ .switchControl:after {
  left: 19px;
}

.switch > .switchControl {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  width: 36px;
  border-radius: 10px;
  background-color: var(--gray);
  transition: background-color 150ms ease-out;
}

.switchDisabled > .switchControl {
  opacity: .4;
}

.switch > .switchControl:before {
  content: "\00a0"; /* needed to keep on same line without having to add &nbsp; in span. */
}

.switch > .switchControl:after {
  content: " ";
  position: absolute;
  left: 3px;
  top: 3px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--white);
  transition: left 150ms ease-out;
}

.switch > .switchLabel {
  margin-left: .5rem;
  font-size: 14px;
  font-weight: 600;
  color: var(--gray-darker);
}
